import { Helpers } from '../../helpers';
import { IConstraintFacilityInitialBuild } from '../../interfaces/iconstraint-facility-initial-build';
import { AreaType } from '../area-type';
import { ConstraintFacilityInitialBuildDetail } from '../constraint-facility-initial-build-detail';
import { Scenario } from '../scenario';

export class ConstraintFacilityInitialBuildBase {
  ConstraintFacilityInitialBuildId: number;
  ScenarioId: number;
  AreaTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintFacilityInitialBuildDetails_ConstraintFacilityInitialBuild?: Array<ConstraintFacilityInitialBuildDetail> | null;
  AreaType?: AreaType;
  Scenario?: Scenario;

  constructor(item?: IConstraintFacilityInitialBuild) {
    if (item) {

      this.ConstraintFacilityInitialBuildId = item.ConstraintFacilityInitialBuildId;
      this.ScenarioId = item.ScenarioId;
      this.AreaTypeId = item.AreaTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintFacilityInitialBuildDetails_ConstraintFacilityInitialBuild = Helpers.createClassArray(ConstraintFacilityInitialBuildDetail, item.ConstraintFacilityInitialBuildDetails_ConstraintFacilityInitialBuild);
      this.AreaType = new AreaType(item.AreaType);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}